// @flow

import { connect } from 'react-redux';

import { atualizaSelecaoTodos } from '../../../../../../../reducers/lista_documentos/nfe';

import SelecaoTodos from '../../common/selecao_todos';

export default connect<*, *, *, *, *, *>(null, { atualizaSelecaoTodos })(SelecaoTodos);